import React, { useEffect, useState } from "react";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import Top from "../Top";
import MaterialTable from "material-table";
import { API_URL } from "../../../config";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const CustomerModule = () => {
  const [users, setUsers] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const [createModal, setCreateModal] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const toggleCreateModal = () => setCreateModal(!createModal);
  const [errors, setErrors] = useState({});

 const [form, setForm] = useState({
  firstname: "",
  lastname: "",
  email: "",
  module_ids: [],
});

  useEffect(() => {
    fetchUsers();
    fetchModules();
  }, []);

  // 🔹 Fetch Type 7 Users
  const fetchUsers = async () => {
    const res = await fetch(API_URL + "/get/type7/user");
    const data = await res.json();
    setUsers(data.users || []);
    setLoading(false);
  };

  // 🔹 Fetch Modules
  const fetchModules = async () => {
    const res = await fetch(API_URL + "/get/all/modules");
    const data = await res.json();
    setModules(data.modules || []);
  };
// 👇 Map plans to module enums
const planModulesMap = {
  ADVANCED: [
    "ADVANCED_FEATURES_MODULE",
    "MULTI_USER_MODULE",
    "PRACTICUMS_MODULE",
    "HRV_MODULE",
  ],
  PROFESSIONAL: [
    "ADVANCED_FEATURES_MODULE",
    "MULTI_USER_MODULE",
    "PRACTICUMS_MODULE",
    "HRV_MODULE",
    "CELL_PHONE_MODULE",
    "CLOUD_DATABASE_MODULE",
    "MANAGEMENT_MODULE",
    "EMG_MUSCLE_FEEDBACK_MODULE",
  ],
};
const handlePlanChange = (planValue) => {
  const selectedEnums = planModulesMap[planValue] || [];

  const selectedModuleIds = modules
    .filter((m) => selectedEnums.includes(m.module_enum))
    .map((m) => m.id);

  setForm({
    ...form,
    module_ids: selectedModuleIds,
  });
};
  // 🔹 Create User
const handleCreateUser = async () => {
  let newErrors = {};

if (!form.firstname.trim()) {
  newErrors.firstname = "First name is required";
}

if (!form.lastname.trim()) {
  newErrors.lastname = "Last name is required";
}

if (!form.email.trim()) {
  newErrors.email = "Email is required";
} else if (!/\S+@\S+\.\S+/.test(form.email)) {
  newErrors.email = "Invalid email format";
}

if (!form.module_ids.length) {
  newErrors.module_ids = "Please select at least one module";
}

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setErrors({});
  setButtonLoader(true);   // ✅ start loader
const distributor_uid = localStorage.getItem("uid");
  try {
    const res = await fetch(API_URL + "/create/type7/user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({...form, distributor_uid}),
    });

    const data = await res.json();

    if (data.success) {
      toggleCreateModal();
      fetchUsers();
      setForm({
  firstname: "",
  lastname: "",
  email: "",
  module_ids: [],
});
    } else {
      setErrors({ email: data.message || "User already exists" });
    }
  } catch (err) {
    setErrors({ email: "Something went wrong" });
  }

  setButtonLoader(false);  // ✅ stop loader
};

  const columns = [
    {
  title: "Name",
  field: "name", 
  render: (row) => `${row.firstname} ${row.lastname}`
},
    { title: "Email", field: "email" },
    {
      title: "Modules",
      field: "modules",
      render: (rowData) =>
        rowData.modules?.length
          ? rowData.modules.map((m) => m.name).join(", ")
          : "No Module",
    },
  ];

  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>

        <div className="right-section">
          <div className="add-btn-wrp">
                       <div className="head-listing">
              <h3>Capno GO Users</h3>
            </div>
        
               <div
                className="add-btn"
                style={{
                  display: "flex",
                  gap: "15px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <button
               onClick={toggleCreateModal}
                >
                   + Create User
                </button>
           
              </div>
          </div>

          <MaterialTable
            title=""
            columns={columns}
            data={users}
            isLoading={loading}
            options={{
              search: true,
              pageSize: 10,
              showTitle: false,
            }}
          />
        </div>
      </div>

      {/* 🔹 Create User Modal */}
      <Modal isOpen={createModal} toggle={toggleCreateModal} centered  // 👈 larger layout
  scrollable>
        <ModalHeader toggle={toggleCreateModal}>
          Create User
        </ModalHeader>
        <ModalBody>
        <FormGroup>
  <Label style={{ margin: 0 ,fontWeight:"bold" }}>First Name</Label>
  <Input
    value={form.firstname}
    className="client-input_value"
    style={{ height: "auto" }}
    invalid={!!errors.firstname}
    onChange={(e) =>
      setForm({ ...form, firstname: e.target.value })
    }
  />
  {errors.firstname && (
    <div style={{ color: "red", fontSize: "13px" }}>
      {errors.firstname}
    </div>
  )}
</FormGroup>
<FormGroup>
  <Label style={{ margin: 0 ,fontWeight:"bold" }}>Last Name</Label>
  <Input
    value={form.lastname}
    className="client-input_value"
    style={{ height: "auto" }}
    invalid={!!errors.lastname}
    onChange={(e) =>
      setForm({ ...form, lastname: e.target.value })
    }
  />
  {errors.lastname && (
    <div style={{ color: "red", fontSize: "13px" }}>
      {errors.lastname}
    </div>
  )}
</FormGroup>

          <FormGroup>
  <Label style={{ margin: 0,fontWeight:"bold" }}>Email</Label>
  <Input
    type="email"
    value={form.email}
    className="client-input_value"
    style={{ height: "auto" }}
    invalid={!!errors.email}
    onChange={(e) =>
      setForm({ ...form, email: e.target.value })
    }
  />
  {errors.email && (
    <div style={{ color: "red", fontSize: "13px" }}>
      {errors.email}
    </div>
  )}
</FormGroup>
<FormGroup>
   <Label style={{ marginBottom: "8px",fontWeight:"bold" }}>Select Modules</Label>
  <Input
    type="select"
    defaultValue=""
    className='client-input_value'
    style={{ height: "auto" }}
    onChange={(e) => handlePlanChange(e.target.value)}
  >
    <option value="">-- Select Module Type --</option>
    <option value="ADVANCED">Capno GO Advanced</option>
    <option value="PROFESSIONAL">Capno GO Professional</option>
  </Input>
</FormGroup>
 <FormGroup>
  {/* <Label style={{ marginBottom: "8px",fontWeight:"bold" }}>Select Modules</Label> */}

  <div
    style={{
      display: "flex",
      flexDirection:"column",
      flexWrap: "wrap",       
      gap: "10px",            
      padding: "12px 16px",    
      border: "1px solid #e5e5e5",
      borderRadius: "6px",
    //   marginTop: "8px",
    }}
  >
    {modules.map((m) => (
      <div
        key={m.id}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 10px",
        }}
      >
        <Input
          type="checkbox"
          checked={form.module_ids.includes(m.id)}
          onChange={(e) => {
            if (e.target.checked) {
              setForm({
                ...form,
                module_ids: [...form.module_ids, m.id],
              });
            } else {
              setForm({
                ...form,
                module_ids: form.module_ids.filter(
                  (id) => id !== m.id
                ),
              });
            }
          }}
        />
        <span>{m.name}</span>
      </div>
    ))}
  </div>

  {errors.module_ids && (
    <div style={{ color: "red", fontSize: "13px", marginTop: "8px" }}>
      {errors.module_ids}
    </div>
  )}
</FormGroup>
        </ModalBody>

        <ModalFooter>
    
      
             <div
                className="add-btn"
                style={{
                  display: "flex",
                  gap: "15px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <button
               onClick={toggleCreateModal}
                >
                   Cancel
                </button>
               <button
  onClick={handleCreateUser}
  disabled={buttonLoader}
>
  {buttonLoader ? (
    <>
      <span
        className="spinner-border spinner-border-sm"
        style={{ marginRight: "8px" }}
      ></span>
      Creating...
    </>
  ) : (
    "Create"
  )}
</button>
           
              </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CustomerModule;